import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { WorkshopBookingService } from '@products/services/workshop-booking.service';
import { BOOKING_DEBOUNCE_TIME } from '@shared/tokens';
import { WorkshopBookingActions } from '@store/products/booking/product/workshop/workshop-booking.actions';
import { WorkshopProductActions } from '@store/products/product.actions';
import { isEmpty } from 'lodash';
import { catchError, debounceTime, EMPTY, map, of, switchMap } from 'rxjs';

export const setBookingWorkshop$ = createEffect(
  (
    actions$ = inject(Actions),
    bookingDebounceTime = inject(BOOKING_DEBOUNCE_TIME, { optional: true }),
    workshopBookingService = inject(WorkshopBookingService)
  ) =>
    actions$.pipe(
      ofType(WorkshopProductActions.setBookingWorkshop),
      debounceTime(bookingDebounceTime),
      switchMap(({ setBookingWorkshops }) => {
        if (isEmpty(setBookingWorkshops)) {
          return EMPTY;
        }

        return workshopBookingService.setWorkshopBookings$(setBookingWorkshops).pipe(
          switchMap((postWorkshopBookings) =>
            workshopBookingService.postAvailableWorkshopBookings$(postWorkshopBookings).pipe(
              workshopBookingService.removeUnassignedTariffsInSetBookingWorkshopsPipe(
                setBookingWorkshops,
                postWorkshopBookings
              ),
              map((setWorkshopBookingsAndSetSeats) =>
                WorkshopBookingActions.setWorkshopInBooking(setWorkshopBookingsAndSetSeats)
              )
            )
          ),
          catchError(() => of(WorkshopBookingActions.setWorkshopInBooking(null)))
        );
      })
    ),
  { functional: true }
);

export const removeBookingWorkshop$ = createEffect(
  (
    actions$ = inject(Actions),
    bookingDebounceTime = inject(BOOKING_DEBOUNCE_TIME, { optional: true }),
    workshopBookingService = inject(WorkshopBookingService)
  ) =>
    actions$.pipe(
      ofType(WorkshopProductActions.removeBookingWorkshop),
      debounceTime(bookingDebounceTime),
      switchMap(({ removeBookingWorkshops }) => {
        if (isEmpty(removeBookingWorkshops)) {
          return EMPTY;
        }

        return workshopBookingService.removeWorkshopBookings$(removeBookingWorkshops).pipe(
          switchMap((postWorkshopBookings) =>
            workshopBookingService
              .postRemoveMultipleWorkshopBookings$(removeBookingWorkshops, postWorkshopBookings)
              .pipe(
                map((removeWorkshopBookingsAndSetSeats) =>
                  WorkshopBookingActions.removeWorkshopFromBooking(removeWorkshopBookingsAndSetSeats)
                )
              )
          ),
          catchError(() => of(WorkshopBookingActions.removeWorkshopFromBooking(null)))
        );
      })
    ),
  { functional: true }
);
